import * as r from '@recoiljs/refine';
import { atom } from 'recoil';
import { urlSyncEffect } from 'recoil-sync';

export interface EmployeeFiltersAtom {
	workStation: string[];
	management: string[];
	board: string[];
	company: string[];
	employee: string;
	teamStructure: string[];
	role: string[];
	noAllocation: boolean;
}

const stringArrayChecker = r.array(r.string()) as r.Checker<string[]>;

export const employeeFiltersAtom = atom<EmployeeFiltersAtom>({
	key: 'employee',
	default: {
		workStation: [],
		management: [],
		board: [],
		company: [],
		employee: '',
		teamStructure: [],
		role: [],
		noAllocation: false,
	},
	effects: [
		urlSyncEffect<EmployeeFiltersAtom>({
			refine: r.object({
				workStation: stringArrayChecker,
				management: stringArrayChecker,
				board: stringArrayChecker,
				company: stringArrayChecker,
				employee: r.string(),
				teamStructure: stringArrayChecker,
				role: stringArrayChecker,
				noAllocation: r.bool(),
			}),
			history: 'push',
		}),
	],
});
